<div class="bulk-actions">
  <div class="summary">
    @if (selectAll) {
      <span>{{ 'DEAD_LETTERS.BULK_ACTIONS.ALL_SELECTED' | translate:{ total: totalCount } }}</span>
    }
    @if (!selectAll) {
      <span>{{ 'DEAD_LETTERS.BULK_ACTIONS.SELECTED_COUNT' | translate:{ count: selectedCount, total: totalCount } }}</span>
    }
  </div>

  <div class="buttons">
    <button
      type="button"
      mat-flat-button
      color="warn"
      [disabled]="!hasSelection || actionInProgress"
      (click)="onResubmitClick()">
      @if (actionInProgress === 'resubmit') {
        <mat-spinner diameter="18"></mat-spinner>
      }
      @if (actionInProgress !== 'resubmit') {
        <span>{{ 'DEAD_LETTERS.BULK_ACTIONS.RESUBMIT' | translate }}</span>
      }
    </button>
    <button
      type="button"
      mat-flat-button
      color="warn"
      [disabled]="!hasSelection || actionInProgress"
      (click)="onRemoveClick()">
      @if (actionInProgress === 'remove') {
        <mat-spinner diameter="18"></mat-spinner>
      }
      @if (actionInProgress !== 'remove') {
        <span>{{ 'DEAD_LETTERS.BULK_ACTIONS.REMOVE' | translate }}</span>
      }
    </button>
  </div>
</div>
